<template>
  <div>
    <Modal
      ref="modal"
      :title="isPreview ? 'Preview Tasks' : 'What tasks should we assign?'"
      :action="action"
      action-color="indigo"
      @close-modal="handleCancel"
      @handle-action="handleAction"
    >
      <RadioSelect v-if="loaded && !isPreview" v-model="selectedChecklist" class="mt-4" :options="checklistOptions" />
      <div v-if="isPreview" class="grid grid-cols-1 gap-2">
        <div v-if="selectedTaskChecklist.checklist_tasks.length > 0">
          <div v-for="task in selectedTaskChecklist.checklist_tasks" :key="task.id" class="p-4 bg-gray-100 rounded-md">
            <p>{{ task.name }}</p>
          </div>
        </div>
        <div v-if="selectedTaskChecklist.checklist_tasks.length == 0">
          <ZeroState>
            <div class="flex justify-center gap-8">
              <header>This checklist has no tasks setup.</header>
            </div>
          </ZeroState>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from '../shared/Modal.vue';
import RadioSelect from '../shared/RadioSelect.vue';
import ZeroState from '../ZeroState.vue';

export default {
  components: {
    Modal,
    RadioSelect,
    ZeroState,
  },
  props: ['record'],
  data() {
    return {
      selectedChecklist: null,
      isPreview: false,
      action: 'Preview',
      loaded: false,
      taskChecklists: [],
    };
  },
  computed: {
    checklistOptions() {
      return this.taskChecklists.map(checklist => ({
        label: checklist.name,
        description: '',
      }));
    },
    selectedTaskChecklist() {
      return this.taskChecklists.find(checklist => checklist.name == this.selectedChecklist);
    },
  },
  mounted() {
    this.getTaskChecklists();
    this.$store.commit('general/hideLocalLoadingSpinner');
  },
  methods: {
    async handleAction() {
      const self = this;

      if (this.isPreview) {
        self.$store.commit('general/showLocalLoadingSpinner');
        await this.assignTasks();
        self.$store.commit('general/hideLocalLoadingSpinner');
      } else {
        self.$store.commit('general/showLocalLoadingSpinner');
        self.isPreview = !self.isPreview;
        self.action = 'Assign';
        self.$store.commit('general/hideLocalLoadingSpinner');
      }
    },
    async assignTasks() {
      const self = this;
      const res = await fetch(`/api/task_checklists/${self.selectedTaskChecklist.id}/task_checklist_assignments`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0]?.content,
        },
        body: JSON.stringify({
          contact_id: self.record.id,
        }),
      });

      const data = await res.json();

      if (data.status != 'error') {
        self.$emit('handleSubmit');
        self.$refs.modal.success();
        self.$store.commit('general/showAlert', {
          alertType: 'success',
          alertTitle: 'Tasks assigned',
          alertDescription: 'The tasks have been successfully assigned. Use the button below to dismiss this alert.',
        });
      } else {
        self.$refs.modal.error();
        self.$store.commit('general/showAlert', {
          alertType: 'error',
          alertTitle: 'Task assignment error',
          alertDescription: data.message,
        });
      }
    },
    handleCancel() {
      this.$emit('handleCancel');
    },
    async getTaskChecklists() {
      const res = await fetch(`/api/task_checklists?status=enabled`);
      const data = await res.json();

      this.taskChecklists = data.records;
      this.selectedChecklist = this.taskChecklists[0].name;
      this.loaded = true;
    },
  },
};
</script>
